export { newReleaseTracks as newReleases, allMusicTracks as allMusic, totalTrackCount } from "./trackCatalog";

export const genres = [
  "All",
  "Afrobeats",
  "Amapiano",
  "R&B",
  "Hip-Hop",
  "Afropop",
  "Gospel",
  "Alte",
  "Highlife"
];
